
import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PLAN_OPTIONS, getPlanOption } from './PlanOptions';

interface SubscriptionStatusSelectProps {
  currentValue: string;
  isUpdating: boolean;
  onValueChange: (value: string) => void;
}

const SubscriptionStatusSelect: React.FC<SubscriptionStatusSelectProps> = ({
  currentValue,
  isUpdating,
  onValueChange
}) => {
  // Get the current plan option based on the value
  const currentPlan = getPlanOption(currentValue);

  return (
    <div className="relative min-w-[150px]">
      <Select 
        value={currentValue} 
        onValueChange={onValueChange}
        disabled={isUpdating}
      >
        <SelectTrigger className={`w-full ${isUpdating ? 'opacity-50' : ''}`}>
          {isUpdating ? (
            <div className="flex items-center">
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
              <span>Updating...</span>
            </div>
          ) : (
            <div className="flex items-center">
              {currentPlan.icon && <span className="mr-2">{currentPlan.icon}</span>}
              <span className={`mr-2 ${currentPlan.textColor}`}>{currentPlan.label}</span>
            </div>
          )}
        </SelectTrigger>
        <SelectContent>
          {PLAN_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              <div className="flex items-center">
                {option.icon && <span className="mr-2">{option.icon}</span>}
                <span className={option.textColor}>{option.label}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SubscriptionStatusSelect;

